import {useState} from 'react'
import CountryDetailsForm from './CountryDetailsForm';
import CountryDetailsList from './CountryDetailsList';

const CountryDetails = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);
  const [serviceId, setServiceId] = useState("none");

return (
  <>
    {fromIsShown ? (
        <CountryDetailsForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
      ) : (
        <CountryDetailsList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
      )}

  </>
)
}

export default CountryDetails